import { VDataTable } from 'vuetify/lib'
import styles from './index.module.less'
import * as _type_name from './type_name'
import { concatClass, setLeft, setRight } from './utils'
import { 
    components as components_hash, 
    handlers as handlers_hash
} from './components/index'
import { EXPAND_FIELD } from './type_name'
const header_keys = [
    ['children', 0],
    ['children', 0],
    ['children', 1],
    ['children', 0],
]
const illegal_val = [null, undefined, '']

const component = {
    props: {
        headers: {
            type: Array,
            default:() => []
        },
        desserts: {
            type: Array,
            default:() => []
        },
        hideDefaultFooter: {
            type:Boolean,
            default: () => true
        },
        loading: {
            type:Boolean,
            default: () => false
        },
        noDataText: {
            type:String,
            default: () => '暂无数据'
        },
        loadingText: {
            type: String,
            default: () => '数据加载中...'
        }
    },
    data() {
        return {
            expands:[],
          //  selected_index:null
        }
    },
    computed: {
        headerSlots() {
            const _this = this
            const component = {}
          const { header } = this.$scopedSlots
          if (header) {
            component.header = (params) => {
               
                params.props.headers = params.props.headers.map(_header => {
                    return {
                        ..._header,
                        class: _this.setHeaderClass(_header),
                        style: _this.headerStyle(_header)
                    }
                })
                    // params.props.headers // setHeaderClass
                return header(params)
            }
          }
            return component
        },
        propsC() {
            return {
                ...this.props
            }
        },
        scoped_slot() {
            return {...this.$scopedSlots}
        },
        headers_computed() {// header暂时不做slot处理
            const left_node_hash = {}
            const left_node_arr = []
            const right_node_hash = {}
            const right_node_arr = []
            const normal_node_arr = []
            const headers_clone = [...this.headers]
            // 检测是否有展开的列，如果有只能有唯一一个展开按钮
            if (headers_clone.filter(item => item.expand).length > 1) {
                console.error('展开列最多只有一个')
                return 
            }
            // 检测
            // 展开列处理
            if (headers_clone.some(item => item.expand)) {
                let expand_col = null
                headers_clone.some((item, index) => {
                    if (item.expand) {
                        expand_col = item
                        headers_clone.splice(index, 1)
                    }
                    return item.expand
                })
                expand_col = {...expand_col}
                expand_col.fixed = 'left',
                expand_col.type = EXPAND_FIELD
                expand_col.width = expand_col.width || 68
                expand_col.text = expand_col.text || '展开'
                headers_clone.unshift(expand_col)
            }
            // console.log('headers_clone', headers_clone)
            headers_clone.forEach(header => {
                if (!header.fixed) {
                    normal_node_arr.push(header)
                    return 
                }
                if (header.fixed === 'left') {
                    const pre_node = left_node_arr[left_node_arr.length - 1]
                    const new_node = {
                        ...header,
                        left:pre_node ? Number(pre_node.left) + Number(pre_node.width) : 0
                    }
                    left_node_arr.push(new_node)
                    left_node_hash[new_node.value] = new_node
                } 
                if (header.fixed === 'right') {
                   const pre_node = right_node_arr[0]
                    const new_node = {
                        ...header,
                       right:pre_node ? Number(pre_node.right) + Number(pre_node.width) : 0
                    }
                    right_node_arr.unshift(new_node)
                    right_node_hash[new_node.value] = new_node
                }

            })
            // console.log('[...left_node_arr, ...normal_node_arr, ...right_node_arr]', [...left_node_arr, ...normal_node_arr, ...right_node_arr])
            return [...left_node_arr, ...normal_node_arr, ...right_node_arr].map(header => {
                const handler = handlers_hash[header.type]
                let headerClone = {...header}
                headerClone.sortable = headerClone.sortable || false
                headerClone = {
                    ...headerClone,
                    ...((headerClone.expand && left_node_hash[header.value]) || {}),
                    ...((headerClone.expand && right_node_hash[header.value]) || {})
                }
                return handler(headerClone)
            })
        },
        initTableProps() {
            return {
                hideDefaultFooter: this.hideDefaultFooter,
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.initHeaders()
        }, 20)

    },
    methods: {
        setHeaderClass(header) {
            return [styles[`text-${header.align}`]].join(' ')
        },
        setTdClass(header, index) {
            return [styles[`text-${header.align}`],
            header.fixed ? styles['fixed-sticky'] : '',
            header.fixed && styles['fixed-sticky-not-hover']
            // header.fixed && this.selected_index !== index ? styles['fixed-sticky-not-hover'] : '',
            // header.fixed && this.selected_index === index ? styles['fixed-sticky-hover'] : '',
           // fixed-sticky-hover
           ].join(' ')
        },
        // hover一行数据
        // selectStyle(index) {
        //     this.selected_index = index
        // },
        // cancelStyle() {
        //     this.selected_index = null
        // },
        // 表头长宽等
        headerStyle(header) {
            if (!header.fixed) {
                return {}
            }
            if (header.fixed === 'left') {
                return {
                    width: `${header.width}px`,
                    left: `${header.left}px`
                }
            } else {
                return {
                    width: `${header.width}px`,
                    right: `${header.right}px`
                }
            }
        },
        // 将不同的数据打到不同的组件上
        componentHandler(header, target, index) {
            const value_key = header.value
            if (this.$scopedSlots[value_key]) {
                return this.$scopedSlots[value_key](target[header.value], target, index)
            }
            if (header.render) {
                return header.render(target[header.value], target, index, this.desserts)
            }
            if (header.renderv) {
                //  header.renderv( target[header.value], target, index, this.desserts)
                return <RenderItem
                    render={(h) => {
                        return header.renderv(h, target[header.value], target, index, this.desserts)
                    }}
                />
            }
            const Component = components_hash[header.type]
            return <Component 
                value={target[header.value]}
                header={header}
                target={target} // expand组件相关
                expands={this.expands} // expand组件相关
                addExchange={this.addExchange} // expand组件相关
                delExchange={this.delExchange} // expand组件相关
                index ={index}
            />
        },
        // 找出fix的表头，以及expand表头
        initHeaders() {
            if (this.$scopedSlots.header) {
                return 
            }
            // 处理fixed列
            const node_header_hash = {}
            if (this.headers_computed.every(header => !header.fixed)) {
                return
            }
            const thead_tr = header_keys.reduce((total, item) => {
                return total[item[0]][item[1]]
             }, this.$refs.tableref.$el || {})
            // 为header的tr增加class
            concatClass(thead_tr, styles.fixed)
            // 获取thead tr下的每一个th节点
            const thead_tds = thead_tr.children
            this.headers_computed.forEach((header, index) => {
                node_header_hash[header.value] = thead_tds[index]
            });

            // 搜集锁定在左边的td
            const left_arr = []
            // 搜集锁定在右边的td
            const right_arr = []
            // console.log('headers_computed_init', this.headers_computed)
            this.headers_computed.forEach((header) => {
                switch (header.fixed) {
                    case 'left':
                        left_arr.push({
                            node:node_header_hash[header.value],
                            vnode: header,
                            distance: 0
                        })
                        break;
                    case 'right':
                        right_arr.unshift({
                            node:node_header_hash[header.value],
                            vnode: header,
                            distance: 0
                        })
                        break;
                    default:
                        break;
                }
            })
            left_arr.forEach((item, index) => {
                const pre_vnode = left_arr[index - 1] || null
                const node = item.node
                const vnode = item.vnode
                // 为当前节点
                concatClass(node, styles['fixed-sticky'])
                concatClass(node, styles['fixed-sticky-not-hover'])
                if (illegal_val.includes(vnode.width)) {
                    console.error(`${vnode.value}需要制定width`)
                    return 
                }
                // 当前节点的宽度固定
                // 当前节点向左的偏移量
                item.distance = !pre_vnode ? 0 : parseInt(pre_vnode.distance) + parseInt(pre_vnode.vnode.width)
                setLeft(item.node, item.distance)
            })
            right_arr.forEach((item, index) => {
                const pre_vnode = right_arr[index - 1] || null
                const node = item.node
                const vnode = item.vnode
                // 为当前节点
                concatClass(node, styles['fixed-sticky'])
                concatClass(node, styles['fixed-sticky-not-hover'])
                if (illegal_val.includes(vnode.width)) {
                    console.error(`${vnode.value}需要制定width`)
                    return 
                }
                item.distance = !pre_vnode ? 0 : parseInt(pre_vnode.distance) + parseInt(pre_vnode.vnode.width)
              
                setRight(item.node, item.distance)
            })
            // style.fixed
        },
        addExchange(target) {
            const first = this.headers_computed[0]
            if (first.change) {
                first.change(target, true)
            }
            this.expands.push(target)
        },
        delExchange(target) {
            const first = this.headers_computed[0]
            if (first.change) {
                first.change(target, false)
            }
            const index = this.expands.indexOf(target)
            this.expands.splice(index, 1)
        }
    },
    render() {
        const headerSlots = this.headerSlots
        const expand_component = this.$scopedSlots.expand
        const _this = this
        return (<VDataTable
            no-data-text={_this.noDataText}
            loading={_this.loading}
            props={this.initTableProps}
            style={{
                width:'100%'
            }}
            items-per-page={Infinity}
            no-data-text={this.noDataText}
            class={styles.table}
            ref="tableref"
            loading-text={this.loadingText}
             hide-default-header={!!headerSlots.header}
            headers={ this.headers_computed }
            items={ this.desserts }
            scopedSlots={{
                ...headerSlots,
                'no-data': () => {
                    return <div>
                    暂无数据
                  </div>
                },
                item: ({item, headers, index}) => {
                    return [
                    <tr
                    // on-mouseenter={() => this.selectStyle(index)}
                    // on-mouseleave={this.cancelStyle}
                    class={[styles.fixed, styles['hover-item']].join(' ')}>
                        {headers.map(header => {
                          
                            return <td
                                class={_this.setTdClass(header)}
                                style={this.headerStyle(header)}
                             >
                               {this.componentHandler(header, item, index)}
                            </td> 
                        })}
                    </tr>,
                    (this.expands.includes(item) && <tr class="v-data-table__expanded v-data-table__expanded__content">
                          <td colspan={headers.length}>
                            {expand_component({item, headers, index}) }
                          </td> 
                    </tr>)
                    ]
                }
            }
        }
        />)
    }
}
export const type_name = _type_name
export default component